if (!customElements.get('fr-collection-tabs')) {
  customElements.define(
    'fr-collection-tabs',
    class FrCollectionTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        if (this.tabs.length < 2) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      activate(index, focus = false) {
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          tab.classList.toggle('is-active', active);
          if (active && focus) tab.focus();
        });

        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      }

      onKeydown(event, index) {
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        this.activate(nextIndex, true);
      }
    }
  );
}
